<script lang="ts">
	import { format } from 'svelte-i18n';
	// Design system components
	import { ControlsContainer, Icon, PlainTable, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { convertToUnit } from 'src/helpers/units_helpers';
	import PVSetupSelfConsumption from './PVSetupSelfConsumption.svelte';
	//Types
	import type { PVSetupTypes } from './pv_setup_helper';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let pvData;
	export let pvSetupType: PVSetupTypes;
	export let staticPreview = false;

	const unit = 'W';
</script>

<ControlsContainer orientation="vertical" class="mb-xs" color={$showNewLayout ? 'color-1' : undefined}>
	<svelte:fragment slot="first">
		<div class="pl-s pr-s">
			<PlainTable class="width-full">
				<colgroup>
					<col class="col-label" />
					<col class="col-value" />
				</colgroup>
				<tbody>
					<tr>
						<th class="pb-m pt-l">
							<div class="th-row">
								<Icon class="mr-s" icon="fas fa-home" size="s" />
								<div class="th-text">
									<Text styleType="h2">
										<span class="ellipsis">
											{$format('label_home_consumption', {
												default: 'Home consumption',
											})}
										</span>
									</Text>
								</div>
							</div>
						</th>
						<td class="pb-m pt-l pl-0 pr-0">
							{convertToUnit(pvData.houseConsumption, unit)}
						</td>
					</tr>
					<tr>
						<th class="pb-m pt-l">
							<div class="th-row">
								<Icon class="mr-s" icon="fas fa-solar-panel" size="s" />
								<div class="th-text">
									<Text styleType="h2">
										<span class="ellipsis">
											{$format('label_pv_generation', {
												default: 'PV generation',
											})}
										</span>
									</Text>
								</div>
							</div>
						</th>
						<td class="pb-m pt-l pl-0 pr-0">
							{convertToUnit(pvData.solarPower, unit)}
						</td>
					</tr>
					<tr>
						<th class="pb-m pt-l">
							<div class="th-row">
								<Icon class="mr-s" icon="fas fa-utility-pole" size="s" />
								<div class="th-text">
									<Text styleType="h2">
										<span class="ellipsis">
											{$format('label_grid_import', {
												default: 'Grid import',
											})}
										</span>
									</Text>
								</div>
							</div>
						</th>
						<td class="pb-m pt-l pl-0 pr-0">
							{convertToUnit(pvData.gridPower, unit)}
						</td>
					</tr>
				</tbody>
			</PlainTable>
		</div>
	</svelte:fragment>
</ControlsContainer>
<PVSetupSelfConsumption {pvSetupType} {staticPreview} />

<style>
	.col-label {
		width: 75%;
	}
	.col-value {
		width: 25%;
	}
	.th-row {
		display: flex;
	}
	.th-text {
		flex: 1 1 auto;
		min-width: 0;
	}
	.ellipsis {
		display: block;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
</style>
